export class Payments {

    name?: any;
    description?: any;
    rate?: number;
    logo?: any;
    status?: any;
    processor?: string;
    processorParams?: any;

    public static getPaidStatuses() {
        return {
            po: "Paid Online",
            pc: "Paid Cash",
            pp: "Partially Paid",
            oc: "On Credit",
            c: "Cheque",
            bt: "Bank Transfer",
            np: "Not Paid",
        }
    }

}